import axios from "./axiosinstance";

const TypeApi = {
  add: (payload) => axios.post("types/add", payload),
  list: () => axios.get("types/list"),
  update: (payload) => axios.post("types/update", payload),
  delete: (payload) => axios.post("types/delete", payload),
};

export default TypeApi;